<template>
	<div :class="[ 'indicator-wrapper', meterChange ]">
		<div class="indicator"></div>
	</div>
</template>

<script>
export default {
	name: 'ChangeIndicator',
	props: {
		meterChange: {
			type: String,
			required: true,
		},
	},
	methods: {
		playSoundFx() {
			this.$store.dispatch("sound/fx/play", { id: `${this.meterChange}` });
		},
	},
	mounted() {
		this.playSoundFx();
	},
};
</script>

<style lang="scss" scoped>
	.indicator-wrapper {
		display: inline-block;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}

	.indicator { height: 100%; }

	.indicator:after {
		content: '▲';
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;

		.decreased & {
			transform: rotate(180deg);
			color: $warning-color;
		}

		.increased & { color: $alt-color; }
		.unchanged & { opacity: 0; }
	}
</style>



// WEBPACK FOOTER //
// src/components/game/review/ChangeIndicator.vue